export type MenuPlaceholderProps = { children: React.ReactNode } & Omit<
    React.ComponentPropsWithoutRef<'div'>,
    'children'
>;

/**
 * Used to render loading or empty state in the menu.
 */
export function MenuPlaceholder(props: MenuPlaceholderProps) {
    const { children, ...rest } = props;

    return (
        <div {...rest} aria-busy className="min-w-48 p-3 text-center whitespace-nowrap text-muted">
            {children}
        </div>
    );
}
